module.exports = __webpack_public_path__ + "static/media/exchangePresChurch.616ebc67.PNG";